module.exports = __webpack_public_path__ + "static/fun-time/games/page005_game1/audio//M_Try again.mp3";